import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from 'react-compare-slider'
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { isMobile } from 'react-device-detect';

export default function ImageCompareView({ firstImageUrl, lastImageUrl }) {

    const { breakpoints } = useTheme();

    const moreThanOneCamera = window.conf.CAMERAS.length > 1
    const isMd = useMediaQuery(breakpoints.down('md'))

    return (
        <Box sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: moreThanOneCamera && !isMobile && !isMd ? "0.2rem" : "0",
            boxSizing: "border-box"
        }}>
            <ReactCompareSlider
                itemOne={
                    <ReactCompareSliderImage
                        src={firstImageUrl}
                        alt="first"
                        style={{ objectFit: "contain", width: "100%", height: "100%" }}
                    />
                }
                itemTwo={
                    <ReactCompareSliderImage
                        src={lastImageUrl}
                        alt="last"
                        style={{ objectFit: "contain", width: "100%", height: "100%" }}
                    />
                }
                handle={
                    <ReactCompareSliderHandle
                        buttonStyle={{
                            backgroundColor: "rgba(255, 255, 255, 0.75)",
                            backdropFilter: "blur(8px)",
                            WebkitBackdropFilter: "blur(8px)",
                            color:  "#333",
                            border: "2px solid rgba(255, 255, 255, 0.75)",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.35)",
                            width: 48,
                            height: 48
                        }}
                        linesStyle={{
                            width: 2,
                            backgroundColor: "rgba(255, 255, 255, 0.75)",
                            boxShadow: "0 0 4px rgba(0, 0, 0, 0.4)",
                        }}
                    />
                }
                style={{ width: "100%", height: "100%" }}
            />
        </Box>
    )
}